<template>
  <div class="pop-manage-detail">
    <section class="pop-detail-tool">
      <el-button
        class="tool-button"
        type="primary"
        v-if="detailInfo.status === 1 && buttonShow"
        @click="downPop"
      >
        {{ $t("couse.undercarriage") }}
      </el-button>
      <el-button
        class="tool-button tool-button-push"
        type="primary"
        v-if="detailInfo.status !== 1 && buttonShow"
        @click="publishPop"
      >
        {{ $t("couse.active") }}
      </el-button>
      <el-button
        class="tool-button"
        type="primary"
        v-if="detailInfo.status !== 1 && buttonShow"
        @click="updatePop(recommendId)"
      >
        {{ $t("update") }}
      </el-button>
      <el-button class="tool-button tool-button-info" type="info" @click="backList">
        {{ $t("course.return") }}
      </el-button>
    </section>
    <section class="pop-detail-info clearfix">
      <div class="detail-info-module detail-info-module1">
        <p class="info-module-name">{{ $t("pop.theme") }}:</p>
        <p class="info-module-value">{{ detailInfo.title }}</p>
      </div>
      <div class="detail-info-module">
        <p class="info-module-name">{{ $t("pop.creatorTitle") }}:</p>
        <p class="info-module-value">{{ detailInfo.creatByDesc }}</p>
      </div>
      <div class="detail-info-module">
        <p class="info-module-name">{{ $t("pop.createTime") }}:</p>
        <p class="info-module-value">{{ detailInfo.creatDate }}</p>
      </div>
      <div class="detail-info-module">
        <p class="info-module-name">{{ $t("pop.editorTitle") }}:</p>
        <p class="info-module-value">{{ detailInfo.chngByDesc }}</p>
      </div>
      <div class="detail-info-module">
        <p class="info-module-name">{{ $t("pop.chgTime") }}:</p>
        <p class="info-module-value">{{ detailInfo.chngDate }}</p>
      </div>
      <div class="detail-info-module">
        <p class="info-module-name">{{ $t("pop.status") }}:</p>
        <div :class="['info-status', 'info-status' + detailInfo.status]">
          {{ detailInfo.statusDesc }}
        </div>
      </div>
    </section>
    <section class="pop-detail-contain clearfix">
      <div class="contain-module">
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.themeTitle") }}</span>
          <span class="li-value">{{ detailInfo.title }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.popType") }}</span>
          <span class="li-value">{{ popType }}</span>
        </div>
        <!-- 微课慕课 学习资料 -->
        <div
          class="module-li clearfix"
          v-if="
            popType === '微课' ||
            popType === '混合式学习' ||
            popType === '慕课' ||
            popType === '资料' ||
            popType === '直播' ||
            popType === '问吧'
          "
        >
          <span class="li-name">{{ $t("pop.connetSelect") }}</span>
          <span class="li-value" style="height: auto;margin-bottom: 20px;">{{ detailInfo.relatedDesc }}</span>
        </div>
        <!-- 网页链接 问卷-->
        <div
          class="module-li clearfix"
          v-if="popType === '网页链接' || popType === '问卷'"
        >
          <span class="li-name">{{ $t("pop.link") }}</span>
          <span class="li-value">{{ detailInfo.content }}</span>
        </div>
        <div class="module-li module-li2 clearfix">
          <span class="li-name">{{ $t("pop.group") }}</span>
          <div class="li-value li-value1" v-if="detailInfo.csList.length > 0">
            <span
              class="group-card"
              v-for="(item, index) in detailInfo.csList"
              :key="'group' + index"
              >{{ item.bizDesc }}</span
            >
          </div>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.creatorTitle") }}</span>
          <span class="li-value">{{ detailInfo.creatByDesc }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.createTime") }}</span>
          <span class="li-value">{{ detailInfo.creatDate }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.publisher") }}</span>
          <span class="li-value">{{ detailInfo.publishedByDesc }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.publishTime") }}</span>
          <span class="li-value">{{ detailInfo.recommendDate }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.editorTitle") }}</span>
          <span class="li-value">{{ detailInfo.chngByDesc }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.chgTime") }}</span>
          <span class="li-value">{{ detailInfo.chngDate }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.popStatus") }}</span>
          <span class="li-value">{{ detailInfo.statusDesc }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.effectivStart") }}</span>
          <span class="li-value">{{ detailInfo.effectiveStartTimeString }}</span>
        </div>
        <div class="module-li clearfix">
          <span class="li-name">{{ $t("pop.effectivEnd") }}</span>
          <span class="li-value">{{ detailInfo.effectiveEndTimeString }}</span>
        </div>
        <div class="module-li module-li2 clearfix" v-if="popType === '图文'">
          <span class="li-name">{{ $t("pop.imgContent") }}</span>
          <span class="li-value">
            <div v-for="(item, index) in imgList" :key="'info' + index">
              <div v-if="item.type===1">
                <el-input
                  style="width: 100%; margin-top: 20px; position: relative;"
                  prop="textarea"
                  type="textarea"
                  :disabled="true"
                  :rows="6"
                  maxlength="500"
                  v-model="item.value"
                  resize="none"
                />
              </div>
              <div v-if="item.type===2">
                <div
                  class="li-value-img"
                >
                  <img alt="" :src="item.value" alt="popImg"/>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
      <div class="contain-module contain-module1">
        <p class="module-cover-title">{{ $t("pop.cover") }}</p>
        <div class="module-cover-img" v-if="detailInfo.picUrl">
          <img alt="" :src="detailInfo.picUrl" alt="popImg"/>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      buttonShow:false,//是否显示上方操作按钮
      detailInfo: {
        csList: [],
        status: 1
      },
      imgList: [],
      imgInfoList: [],
      popType: "",
      recommendId: ''
    };
  },
  methods: {
    formDateTime(val) {
      let date = new Date(val * 1);
      let year = date.getFullYear();
      let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
    },
    // 初始化数据
    initData() {
      if (this.recommendId) {
        let params = {
          recommendId: this.recommendId,
        };
        this.imgList = []
        this.$request.post("/sys/popsUpMsg/initEdit", params).then((res) => {
          if (res) {
            let data = res.recommendVO;
            let typeList = res.recommendTypes || [];
            typeList.forEach((item) => {
              if (item.key === data.type) {
                this.popType = item.value;
              }
            });
            let content = "";
            if (data.graphicsContext) {
              let arr = JSON.parse(data.graphicsContext) || [];
              this.imgList = arr;
            }
            this.content = content.value;
            if (data.creatDate.indexOf("-") === -1) {
              data.creatDate = this.formDateTime(data.creatDate);
            }
            if (data.chngDate.indexOf("-") === -1) {
              data.chngDate = this.formDateTime(data.chngDate);
            }
            if (data.recommendDate && data.recommendDate.indexOf("-") === -1) {
              data.recommendDate = this.formDateTime(data.recommendDate);
            }
            this.detailInfo = data;
            this.buttonShow = true;
          }
        });
      }
    },
    // 返回列表页面
    backList() {
      this.tabRemove()
      this.detailInfo = {
        csList: [],
        status: 1
      };
      this.recommendId = ''
      this.$router.push({
        name: "sys-communicationPop-popManage",
        params: {
          update: true
        }
      });
      this.$eventHub.$emit('popManageList','')
    },
    // 跳转编辑页面
    updatePop(val) {
      this.tabRemove()
      this.$router.push({
        name: "sys-communicationPop-popManageEdit",
        query: {
          edit: 0,
          recommendId: val,
        },
      });
      this.$eventHub.$emit('popManageEdit','')
    },
    // 下架的被上架
    publishPop() {
      this.$confirm(this.$t("pop.confirmUp"), this.$t("prompt.title"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      }).then(() => {
        let params = {
          recommendId: this.recommendId,
          currentUserCode: JSON.parse(sessionStorage.getItem('v1user_data')).userCode
        };
        this.$request.post("/sys/popsUpMsg/updateStatus", params).then((res, total, code, data) => {
          if (res) {
            console.log("==============",data.data.message)
            if (res.status === "success") {
              this.$message({
                message: data.data.message === 'success' ? "发布成功" :data.data.message,
                type: "success",
              });
              this.backList();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          }
        });
      });
    },
    // 下架
    downPop() {
      this.$confirm(this.$t("pop.confirmDown"), this.$t("prompt.title"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      }).then(() => {
        let params = {
          recommendId: this.recommendId,
          status: 9,
          currentUserCode: JSON.parse(sessionStorage.getItem('v1user_data')).userCode
        };
        this.$request.post("/sys/popsUpMsg/updatePopUpsStatus", params).then((res) => {
          if (res) {
            if (res.status === "success") {
              this.$message({
                message: "下架成功",
                type: "success",
              });
              this.backList();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          }
        });
      });
    },
    // 删除当前页面
    tabRemove() {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name})
      }
    },
  },
  mounted() {
    this.recommendId = this.$route.query.recommendId
    this.initData();
    this.$eventHub.$on('popManageDetail', () => {
      this.detailInfo = {
        csList: [],
      };
      this.imgInfoList = []
      this.imgList = []
      this.initData();
    })
  },
};
</script>
<style lang="scss" scoped>
.pop-manage-detail {
  height: 100%;
  .pop-detail-tool {
    text-align: right;
    background-color: #ffffff;
    padding: 12px;
    margin-bottom: 12px;
    .tool-button {
      widows: 80px;
      display: inline-block;
      &.tool-button-push {
        background: rgb(102, 197, 177) !important;
        border: 1px solid rgb(102, 197, 177) !important;
        &:hover {
          opacity: 0.8;
          background: rgb(102, 197, 177) !important;
        }
      }
    }
  }
  .pop-detail-info {
    background-color: #ffffff;
    height: 84px;
    padding: 18px 30px;
    margin-bottom: 12px;
    .detail-info-module {
      width: 16%;
      height: 100%;
      float: left;
      position: relative;
      padding-right: 20px;
      &.detail-info-module1 {
        width: 20%;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 20px;
        height: 100%;
        width: 1px;
        background-color: #dcdfe6;
      }
      &:last-child::after {
        display: none;
      }
      p {
        margin: 0;
        height: 22px;
        line-height: 22px;
      }
      .info-module-name {
        margin-bottom: 2px;
      }
      .info-module-value {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info-status {
        height: 22px;
        line-height: 22px;
        text-align: center;
        width: 100px;
        color: #ffffff;
        &.info-status1 {
          background-color: #65b0f3;
        }
        &.info-status0 {
          background-color: #fe7aa2;
        }
        &.info-status9 {
          background-color: #2c3d51;
        }
      }
    }
  }
  .pop-detail-contain {
    background-color: #ffffff;
    padding: 12px;
    .contain-module {
      height: 100%;
      width: 50%;
      float: left;
      padding-left: 10px;
      &.contain-module1 {
        display: flex;
        padding-top: 16px;
        .module-cover-title {
          height: 32px;
          line-height: 32px;
          margin: 0;
          margin-right: 50px;
        }
        .module-cover-img {
          width: 160px;
          height: 208px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
      .module-li {
        height: 32px;
        line-height: 32px;
        margin: 16px 0;
        &.module-li2 {
          height: auto;
        }
        .li-name {
          display: block;
          width: 110px;
          height: 100%;
          float: left;
        }
        .li-value {
          display: block;
          width: calc(100% - 110px);
          height: 100%;
          float: left;
          color: #626262;
          font-size: 13px;
          .el-textarea {
            margin:0 0 20 0!important;
          }
          &.li-value1 {
            line-height: 32px;
            min-height: 32px;
            height: auto;
            border: 1px solid #bbbbbb;
            border-radius: 5px;
            width: calc(60% - 110px);
            padding: 8px 0 0 8px;
            display: flex;
            flex-wrap: wrap;
            .group-card {
              background-color: #3278b4;
              font-size: 12px;
              height: 32px;
              margin: 0 8px 8px 0;
              padding: 0 9px;
              color: #ffffff;
              border-radius: 4px;
              cursor: pointer;
              font-weight: normal;
            }
          }
          .li-value-img {
            width: 300px;
            height: 118px;
            display: flex;
            margin: 10px 0;
            border:1px dashed #dcdfe6;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
  }
}
</style>
